export const SYSTEM = {
  MARKS: 'marks',
  SKATING: 'skating',
  AJS: 'ajs',
  AJS_FORMATION: 'ajs_formation',
  AJS_SHOWDANCE: 'ajs_showdance',
  AJS_3: 'ajs_3',
  S3_6: 's3-6',
  S_AJS: 's-ajs',
  AJS24: 'ajs24',
  AJS27: 'ajs27',
  EL_AJS: 'el_ajs',
  // Breaking: solo pre-selection scoring (One-Fader, 0-100)
  BREAKING_PRESELECTION: 'breaking_preselection',
  // Breaking: head-to-head battle scoring. The comparative sliders a judge
  // scores on come from the category's judging level, not from this system.
  BREAKING_BATTLE: 'breaking_battle',
} as const;

export default SYSTEM;
type t = typeof SYSTEM;
export type SystemType = t[keyof t];
